export default {
  float: () => {
    let seed = new Date().getTime();
    seed = (seed * 9301 + 49297) % 233280;
    seed /= 233280.0;
    return seed * 1;
  }
};
